import { AfterViewInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { BasePage } from '../../base.page';
import { ConfirmDialog } from '../../../ui/dialog/confirm/confirm.dialog';
import { ContractInterface, EvaluateFeeUseCase, GetContractDataUseCase, GetContractUseCase, TransferInterface } from '../../../../core';
import { ContributionPage } from '../contribution.page';
import { Fee, Id, Transfer } from '../../../domain/data';
import { ErrorDialog } from '../../../ui/dialog/error/error.dialog';
import { MainRoutes } from '../../../main-routes.enum';
import { ParentEvents } from '../../../utils/parent-events.service';
import { Serializer } from '../../../client/helpers/serializer/serializer';

@Component({
    templateUrl: './contribution-operate.page.html',
    styleUrls: ['./contribution-operate.page.scss'],
})
export class ContributionOperatePage extends BasePage implements AfterViewInit, OnInit {
    private contract: ContractInterface;
    public transfer: TransferInterface;

    constructor(
        contributionPage: ContributionPage,
        parentEvents: ParentEvents,
        private dialog: MatDialog,
        private evaluateFeeUseCase: EvaluateFeeUseCase,
        private getContractDataUseCase: GetContractDataUseCase,
        private getContractUseCase: GetContractUseCase,
        private router: Router,
        private serializer: Serializer
    ) {
        super(parentEvents);
        contributionPage.hideBackButton();
    }

    ngOnInit(): void {
        this.getContract();
    }

    private getContract(): void {
        this.getContractUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (contract) => {
                    this.contract = contract;
                    this.transfer = new Transfer(contract.encryptedCode as Id);
                },
                (throwable) =>
                    this.dialog.open(ErrorDialog, {
                        data: { text: throwable.message },
                    })
            );
        });
    }

    onSubmit() {
        const updateAndRedirect = (changed: boolean) => {
            this.router.navigateByUrl(MainRoutes.CONTRIBUTION_SIGN, {
                state: {
                    transfer: this.serializer.toJson(this.transfer),
                    changed,
                },
            });
        };

        this.getContractDataUseCase.bind().subscribe((transaction) => {
            transaction.fold(
                (data) => {
                    const fee = new Fee(this.transfer.total, data.modelId);
                    fee.evaluationType = 'contribution';

                    this.evaluateFeeUseCase.bind({ data: fee }).subscribe((transactionFee) => {
                        transactionFee.fold(
                            (feedAmount) => {
                                if (this.contract.feedAmount !== feedAmount) {
                                    this.dialog
                                        .open(ConfirmDialog, {
                                            data: {
                                                text: 'dialog.change-rate-contribution',
                                                params: {
                                                    rate: feedAmount.toFixed(2),
                                                },
                                            },
                                        })
                                        .afterClosed()
                                        .subscribe((result) => {
                                            if (result) {
                                                updateAndRedirect(true);
                                            }
                                        });
                                } else {
                                    updateAndRedirect(false);
                                }
                            },
                            (throwable) =>
                                this.dialog.open(ErrorDialog, {
                                    data: { text: throwable.message },
                                })
                        );
                    });
                },
                (throwable) =>
                    this.dialog.open(ErrorDialog, {
                        data: { text: throwable.message },
                    })
            );
        });
    }
}
